import axios from '@/store/api.js'

const state = {
    reportBalanceList: [],
    selectedReportBalanceSetting: {},
    filters: {
        // kpi
        onGoing: false,
        correction: false,
        // other
        searchString: '',
        projectStatusCodes: [],
        selectedTab: 'projects',
        currentPageProjects: 1,
        currentPageReports: 1,
        currentPageJobs: 1
    }
}

const getters = {
    getReportBalanceList: state => {
        return state.reportBalanceList
    },
    getSelectedReportBalanceSetting: state => {
        return state.selectedReportBalanceSetting
    },
    getFilters: state => {
        return state.filters
    }
}

const mutations = {
    setReportBalanceList: (state, balanceList) => {
        state.reportBalanceList = balanceList
    },
    setSelectedReportBalanceSetting: (state, payload) => {
        let sortedArr = payload.sort((a, b) => {
            let keyA = a.sortering
            let keyB = b.sortering

            if (keyA < keyB) {
                return -1
            }
            if (keyA > keyB) {
                return 1
            }
            return 0
        })
        state.selectedReportBalanceSetting = sortedArr[0]
    },
    setFilter: (state, filter) => {
        if (!filter.handler) {
            state.filters[filter.key] = filter.value
            // only one kpi active at once
            if (filter.key === 'onGoing') {
                state.filters.correction = false
            }
            if (filter.key === 'correction') {
                state.filters.onGoing = false
            }
        } else {
            if (filter.handler === 'splice') {
                state.filters[filter.key].splice(filter.value, 1)
            }
            if (filter.handler === 'push') {
                state.filters[filter.key].push(filter.value)
            }
        }
    }
}

const actions = {
    async setReportBalanceList ({ commit, rootState }) {
        try {
            let accountingTypeId = null
            if (rootState.global.selectedRegnskab.id) {
                accountingTypeId = rootState.global.selectedRegnskab.id
            } else {
                accountingTypeId = rootState.global.selectedRegnskab
            }

            const response = await axios.post('/Value/Report/GetReportBalanceList', {
                regnskabId: accountingTypeId
            })
            if (response) {
                commit('setReportBalanceList', response.data)
                commit('setSelectedReportBalanceSetting', response.data)
            }
        } catch (err) {
            throw err
        }
    },
    setFilter: ({ commit }, filter) => {
        commit('setFilter', filter)
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/dashboard/dashboard.js